export let basicCartVariantProps = {
    key: 0,
    item_id: null,
    item_detail: {id: 0, profile_photo: '', sku_code: '', article_name: '', unit_name: ''},
    photo_list: []
}

export let customChoiceFabric = {
    key: 0,
    suggested_fabric: [],
    style_option_id: 0
}

export let footerNoteProps = {
    key: 0,
    title: '',
    description: ''
}

export let dataProps = {
    id: 0,
    active: true,
	inventory_item: {id: null, sku_code: '', article_name: '', photo_list: []},
    
    category_id_list: [],
	
    listing_title: '',
	listing_price: 0,
	listing_discounted_price: 0,
	
    basic_cart_selection_variant_id: 0,
	basic_cart_selection_item_list: [],
	
    other_selection_variant_id: 0,
	other_selection_variant_item_list: [],
	
    look_book_item_list: [],
	
    can_customise: false,
    customise_tailoring_optional: true,
    
	customise_tailoring_item_template: {id: null, template_name: '', style_choice_list: [], custom_choice_list: []},
    default_stitching_fabric: { id: 0, sku_code: '', article_name: '' },
    suggested_base_fabric: [],
    custom_choise_fabric: [],
	
    footer_note_list: [JSON.parse(JSON.stringify(footerNoteProps))],
    applicable_stores: []
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreProduct/properties.js